export class TaggedUrl {
    private static tagsRegExp: RegExp = /\[([\w\-]+)\]/g;
    private static regExpForRemoveTags: RegExp = /\[[\w\-]+\]+\s*/g;

    public readonly taggedUrl: string;
    public readonly url: string;
    public readonly tags: string[];

    public constructor(taggedUrl: string) {
        this.taggedUrl = taggedUrl;
        this.url = TaggedUrl.extractUrl(taggedUrl).trim();
        this.tags = TaggedUrl.extractTags(this.taggedUrl);
    }

    public hasTag(tag: string): boolean {
        return this.tags.indexOf(tag) > -1;
    }

    public hasAnyTag(tags: string[]){
        return tags.reduce((previous, tag) => this.tags.includes(tag) || previous, false)
    }

    public static join(url: string, tags: string[]): string {
        return `${tags.map(elem => `[${elem}]`).join(' ')} ${url}`;
    }

    public static extractTags(url: string): string[] {
        const tags: string[] = url.match(TaggedUrl.tagsRegExp) || [];
        const filteredTags: string[] = tags
            .filter((e, i, arr) => arr.lastIndexOf(e) === i)
            .map(value => value.replace(/\[/, '').replace(/\]/, ''));

        return filteredTags;
    }

    public static extractUrl(taggedUrl: string): string {
        return taggedUrl.replace(TaggedUrl.regExpForRemoveTags, '');
    }
}
